/* eslint-disable jira/filename-case, no-restricted-properties */
import noop from 'lodash/noop';

const getPerf = (): Performance => {
	try {
		// TODO - Write up an explanation to why we are doing this, if this method is approved.

		// oxlint-disable no-cond-assign
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.performance.clearResourceTimings ? (window.performance.clearResourceTimings = noop) : '';

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		return window.performance;
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		// no op implementation
		return {
			now: () => 0,
			// @ts-expect-error - TS2322 - Type 'void' is not assignable to type 'PerformanceMark'.
			mark: noop,
			clearMarks: noop,
			clearResourceTimings: noop,
			getEntriesByType: (_type: string) => [],
			getEntriesByName: (_name: string) => [],
			// Replace with lodash/noop
			// @ts-expect-error - TS2322 - Type 'void' is not assignable to type 'PerformanceMeasure'.
			measure: (_measureName: string, _start: string, _end: string) => {
				/* empty */
			},
		};
	}
};
const perf: Performance = getPerf();
export default perf;
